export interface Person_Document_Interface {
  id:number,
  person_id:number,

  grpDoc_id:number,
  grpDocTitle:String,

  tlDoc_id:number,
  tlDocTitle:String,

  shomareh:String,
  taminKonandeh:String,
}

export function Empty_Person_Document_Interface(){
  return{
    id:0,
    person_id:0,

    grpDoc_id:0,
    grpDocTitle:'',

    tlDoc_id:0,
    tlDocTitle:'',

    shomareh:'',
    taminKonandeh:'',
  }
}

